import Percentage from "../../../Percentage";

interface ISidePanelPercentageFull {
    percentageFull: number
}

export default function SidePanelPercentageFull({ percentageFull }: ISidePanelPercentageFull) {
    return (<>
        <div style={{ width: 100, height: 100 }} className="margin__top--xxs">
            <Percentage amount={percentageFull} />
        </div>
    </>
    )
}